"use client";
import { jsx } from "react/jsx-runtime";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Divider as Divider$1 } from "@mantine/core";
import { forwardRef } from "react";
const _Divider = forwardRef((props, ref) => {
  const { text, textPosition, color, opacity = 1, className, style, mod, ...rest } = props;
  const styleVariables = {
    "--passed-opacity": opacity
  };
  return /* @__PURE__ */ jsx(
    Divider$1,
    {
      ...rest,
      ref,
      className,
      label: text,
      mod: { color, ...mod },
      style: { ...styleVariables, ...style },
      labelPosition: textPosition
    }
  );
});
_Divider.displayName = "Divider";
const Divider = sharedHandler(_Divider);
Divider.displayName = _Divider.displayName;
export {
  Divider as default
};
